import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    gridContainer: {
      marginBottom: theme.spacing(12),
    },
    gridChild: {
      display: "flex",
      flexDirection: "column",
    },
  }),
);
